import documentReady from './documentReady.ts'

function init () {
  const link = document.getElementById('mobileAlertReadMore')
  const desktopAlert = document.querySelector('.desktop')
  const mobileAlert = document.querySelector('.mobile')
  if (link && desktopAlert) {
    const toggleAlert = function () {
      if (link.classList.contains('active')) {
        desktopAlert.style.display = 'none'
        mobileAlert.style.display = 'inline'
        link.innerHTML = 'more...'
        link.classList.remove('active')
      } else {
        desktopAlert.style.display = 'block'
        mobileAlert.style.display = 'none'
        link.innerHTML = 'less...'
        link.classList.add('active')
      }
    }
    link.addEventListener('click', toggleAlert)
  }
}

documentReady(init)
